import { useState, useEffect, useCallback } from 'react';
import { authFetch } from '../utils/api';

export const useTrialStatus = () => {
    const [trialStatus, setTrialStatus] = useState({
        loading: true,
        hasTrial: false,
        isExpired: false,
        daysRemaining: 0,
        trialEndDate: null,
        status: null
    });

    // Check for admin role immediately
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isAdmin = user && user.role === 'admin';

    const fetchTrialStatus = useCallback(async () => {
        if (isAdmin) {
            setTrialStatus({
                loading: false,
                hasTrial: false,
                isExpired: false,
                daysRemaining: 1000,
                trialEndDate: null,
                status: 'active',
                planName: 'Lifetime Admin'
            });
            return;
        }

        try {
            console.log('📡 Fetching trial status from API...');
            const response = await authFetch('/api/subscription/trial/status');

            console.log('📡 API Response status:', response.status, response.ok);

            if (response.ok) {
                const data = await response.json();
                console.log('📡 Trial status data received:', data);
                setTrialStatus({
                    loading: false,
                    ...data
                });
            } else {
                console.error('❌ Failed to fetch trial status:', response.status);
                setTrialStatus(prev => ({ ...prev, loading: false }));
            }
        } catch (error) {
            console.error('❌ Error fetching trial status:', error);
            setTrialStatus(prev => ({ ...prev, loading: false }));
        }
    }, [isAdmin]);

    useEffect(() => {
        fetchTrialStatus();

        // Refresh every 5 minutes
        const interval = setInterval(fetchTrialStatus, 5 * 60 * 1000);

        // Immediately re-fetch when payment succeeds (triggered from SubscriptionPage)
        const handlePaymentSuccess = () => {
            console.log('💳 Payment success event received — refreshing trial status...');
            fetchTrialStatus();
        };
        window.addEventListener('paymentSuccess', handlePaymentSuccess);

        return () => {
            clearInterval(interval);
            window.removeEventListener('paymentSuccess', handlePaymentSuccess);
        };
    }, [fetchTrialStatus]);

    return { ...trialStatus, refetch: fetchTrialStatus };
};
